/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { dispatchGetAllUsers, fetchAllUsers } from '../../../../redux/actions/usersAction'
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'
import { isLength, isMatch } from '../../../../utils/validation/Validation'
// import { appAddress } from '../../../../App'
import DashNavbar from '../navbar/Navbar'
import DashMenu from '../menu/DashMenu'
import DashFooter from '../footer/DashFooter'
import i18n from '../../../../i18n'
import { useTranslation } from 'react-i18next'
import { appAddress } from '../../../../App'

// import Dashboard from '../admin/Dashboard'

const initialState = {
  name: '',
  email: '',
  userName: '',
  password: '',
  cf_password: '',
  err: '',
  success: ''
}

export default function Profile() {
  const {t} = useTranslation()

  const auth = useSelector(state => state.auth)
  const token = useSelector(state => state.token)

  // const users = useSelector(state => state.users)

  const {user, isAdmin} = auth
  const [data, setData] = useState(initialState)
  const {name, password, cf_password} = data
  const [callback] = useState(false)

  const dispatch = useDispatch()


  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);

    const rootElement = document.getElementById('root');
    if (savedLanguage === 'fa' || savedLanguage === 'ar') {
      rootElement.classList.remove('ltr', 'text-left');
      rootElement.classList.add('rtl', 'text-right');
    } else {
      rootElement.classList.remove('rtl', 'text-right');
      rootElement.classList.add('ltr', 'text-left');
    }
  }, []);

  useEffect(()=>{
    if(isAdmin){
      fetchAllUsers(token).then(res=>{
        dispatch(dispatchGetAllUsers(res))
      })
    }
  },[token, isAdmin, dispatch, callback])


  const handleChange = e => {
    const {name, value} = e.target
    setData({...data, [name]:value, err:'', success: ''})
}


const updateInfor = () => {
  try {
    axios.patch(`${appAddress}/user/update`, {
    // axios.patch(`/user/update`, {
        name: name ? name : user.name
    },{
        headers: {Authorization: token}
    })

    setData({
        ...data, err: '',
        success: toast.success("Profile updated", {
    position:"bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    })
       
    })
} catch (err) {
    setData({
        ...data,
        err: toast.error(err.response.data.msg, {
    position:"bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    })
       , success: ''
    })
  }
}


const updatePassword = () => {
  if(isLength(password))
      return setData({
          ...data,
          err: toast.error("Password must be more than 6 characters", {
      position:"bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      })
          , success: ''
      })

  if(!isMatch(password, cf_password))
      return setData({
          ...data,
          err: toast.error("Password does not match", {
      position:"bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      })
          , success: ''
      })

  try {
      axios.post(`${appAddress}/user/reset`, {password},{
      // axios.put('/user/reset', {password},{
          headers: {Authorization: token}
      })

      setData({
          ...data, err: '',
           success: toast.success("password updated", {
      position:"bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      })
         
      })
  } catch (err) {
      setData({
          ...data,
          err: toast.error(err.response.data.msg, {
      position:"bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      })
         , success: ''
      })
  }
}


const handleUpdate = () => {
  if(name) updateInfor()
  if(password) updatePassword()
}




  return (
    <>
      <div className='bg-[#2a3447] text-teal-50 ltr w-[100%]  font-englishTitle'>
      <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl
              pauseOnFocusLoss
              draggable
              pauseOnHover/>
      <DashNavbar />
      <div className='flex mt-11'>
        <div className='w-[250px] p-5 border-r-4 '>
          <DashMenu />
        </div>
        <div className='p-4 w-[100%] '>
          <div className=' w-[100%] flex flex-col justify-center items-center gap-4 '>      
               <h2 className='font-englishTitle text-xl'>{t("profle")}</h2>
               <hr className='bg-slate-500 w-[15%] mb-3' />
             <div className=' w-[90%] h-[500px] z-10 border rounded-lg laptop:mt-4 border-slate-600'>
               <form className='flex flex-col items-center justify-center gap-5 mt-20 '>
                 <div className=' w-[80%] flex flex-col desktop:flex-row  justify-around items-center gap-4 p-2 mb-7  '>
                   <div className='w-[80%] desktop:w-[40%] m-auto'>
                     <input className='font-english text-center w-[100%] desktop:w-[350px] text-black outline outline-offset-2 outline-2 outline-zinc-50' type="text"  name='name' id='name' onChange={handleChange} defaultValue={user.name} placeholder='Full Name'/>
                   </div>
                   <div className='w-[80%] desktop:w-[40%]'>
                     <input className='font-english text-center w-[100%] desktop:w-[350px] text-black outline outline-offset-2 outline-2 outline-zinc-50' disabled type="text"  name='email' id='email' onChange={handleChange} defaultValue={user.email} placeholder='Email'/>
                   </div>
                 </div>
               
                 <div className=' w-[80%] flex flex-col desktop:flex-row justify-around items-center gap-4 p-2 mt-4 mb-7 '>
                   <div className='w-[80%] desktop:w-[40%]  m-auto'>
                     <input className='font-english text-center w-[100%] desktop:w-[350px] text-black outline outline-offset-2 outline-2 outline-zinc-50' type="password" onChange={handleChange} value={password} name='password' id='password' placeholder={t("newPass")}/>
                   </div>
                   <div className='w-[80%] desktop:w-[40%] '>
                     <input className='font-english text-center w-[100%] desktop:w-[350px] text-black outline outline-offset-2 outline-2 outline-zinc-50' type="password" onChange={handleChange} value={cf_password} name='cf_password' id='password' placeholder={t("confNewPass")}/>
                   </div>
                 </div>
                 <button className='bg-zinc-600 hover:bg-zinc-800 w-[150px] h-[35px] rounded-md'><a onClick={handleUpdate}>{t("submit")}</a></button>
               </form>
             </div>
           </div>

        </div>
      </div>
      <div className='mt-11'>
        <DashFooter />
      </div>
    </div>
    </>

  )
}
